export const FormatsData: import('../../../sim/dex-species').ModdedSpeciesFormatsDataTable = {
	bulbasaur: {
		tier: "LC",
	},
	ivysaur: {
		tier: "NFE",
	},
	venusaur: {
		tier: "RU",
		doublesTier: "DOU",
	},
	venusaurmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	charmander: {
		tier: "LC",
	},
	charmeleon: {
		tier: "NFE",
	},
	charizard: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	charizardmegax: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	charizardmegay: {
		tier: "OU",
		doublesTier: "DOU",
	},
	squirtle: {
		tier: "LC",
	},
	wartortle: {
		tier: "NFE",
	},
	blastoise: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	blastoisemega: {
		tier: "UU",
		doublesTier: "DUU",
	},
	caterpie: {
		tier: "LC",
	},
	metapod: {
		tier: "NFE",
	},
	butterfree: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	weedle: {
		tier: "LC",
	},
	kakuna: {
		tier: "NFE",
	},
	beedrill: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	beedrillmega: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	pidgey: {
		tier: "LC",
	},
	pidgeotto: {
		tier: "NFE",
	},
	pidgeot: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	pidgeotmega: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	rattata: {
		tier: "LC",
	},
	raticate: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	spearow: {
		tier: "LC",
	},
	fearow: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	ekans: {
		tier: "LC",
	},
	arbok: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	pichu: {
		tier: "LC",
	},
	pikachu: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	pikachucosplay: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	pikachurockstar: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	pikachubelle: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	pikachupopstar: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	pikachuphd: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	pikachulibre: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	raichu: {
		tier: "PU",
		doublesTier: "DOU",
	},
	sandshrew: {
		tier: "LC",
	},
	sandslash: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	nidoranf: {
		tier: "LC",
	},
	nidorina: {
		tier: "NFE",
	},
	nidoqueen: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	nidoranm: {
		tier: "LC",
	},
	nidorino: {
		tier: "NFE",
	},
	nidoking: {
		tier: "UU",
		doublesTier: "DUU",
	},
	cleffa: {
		tier: "LC",
	},
	clefairy: {
		tier: "PU",
		doublesTier: "NFE",
	},
	clefable: {
		tier: "OU",
		doublesTier: "DUU",
	},
	vulpix: {
		tier: "LC",
	},
	ninetales: {
		tier: "PU",
		doublesTier: "DUU",
	},
	igglybuff: {
		tier: "LC",
	},
	jigglypuff: {
		tier: "NFE",
	},
	wigglytuff: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	zubat: {
		tier: "LC",
	},
	golbat: {
		tier: "RU",
		doublesTier: "NFE",
	},
	crobat: {
		tier: "UU",
		doublesTier: "DUU",
	},
	oddish: {
		tier: "LC",
	},
	gloom: {
		tier: "NFE",
	},
	vileplume: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	bellossom: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	paras: {
		tier: "LC",
	},
	parasect: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	venonat: {
		tier: "LC",
	},
	venomoth: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	diglett: {
		tier: "LC",
	},
	dugtrio: {
		tier: "(OU)",
		doublesTier: "(DUU)",
	},
	meowth: {
		tier: "LC",
	},
	persian: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	psyduck: {
		tier: "LC",
	},
	golduck: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	mankey: {
		tier: "LC",
	},
	primeape: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	growlithe: {
		tier: "LC",
	},
	arcanine: {
		tier: "UU",
		doublesTier: "DOU",
	},
	poliwag: {
		tier: "LC",
	},
	poliwhirl: {
		tier: "NFE",
	},
	poliwrath: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	politoed: {
		tier: "ZU",
		doublesTier: "DOU",
	},
	abra: {
		tier: "LC",
	},
	kadabra: {
		tier: "PU",
		doublesTier: "NFE",
	},
	alakazam: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	alakazammega: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	machop: {
		tier: "LC",
	},
	machoke: {
		tier: "PUBL",
		doublesTier: "NFE",
	},
	machamp: {
		tier: "UU",
		doublesTier: "DUU",
	},
	bellsprout: {
		tier: "LC",
	},
	weepinbell: {
		tier: "NFE",
	},
	victreebel: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	tentacool: {
		tier: "LC",
	},
	tentacruel: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	geodude: {
		tier: "LC",
	},
	graveler: {
		tier: "NFE",
	},
	golem: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	ponyta: {
		tier: "LC",
	},
	rapidash: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	slowpoke: {
		tier: "LC",
	},
	slowbro: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	slowbromega: {
		tier: "(OU)",
		doublesTier: "(DUU)",
	},
	slowking: {
		tier: "RU",
		doublesTier: "DUU",
	},
	magnemite: {
		tier: "LC",
	},
	magneton: {
		tier: "RU",
		doublesTier: "NFE",
	},
	magnezone: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	farfetchd: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	doduo: {
		tier: "LC",
	},
	dodrio: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	seel: {
		tier: "LC",
	},
	dewgong: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	grimer: {
		tier: "LC",
	},
	muk: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	shellder: {
		tier: "LC",
	},
	cloyster: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	gastly: {
		tier: "LC",
	},
	haunter: {
		tier: "NU",
		doublesTier: "NFE",
	},
	gengar: {
		tier: "OU",
		doublesTier: "DOU",
	},
	gengarmega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	onix: {
		tier: "LC",
	},
	steelix: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	steelixmega: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	drowzee: {
		tier: "LC",
	},
	hypno: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	krabby: {
		tier: "LC",
	},
	kingler: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	voltorb: {
		tier: "LC",
	},
	electrode: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	exeggcute: {
		tier: "LC",
	},
	exeggutor: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	cubone: {
		tier: "LC",
	},
	marowak: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	tyrogue: {
		tier: "LC",
	},
	hitmonlee: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	hitmonchan: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	hitmontop: {
		tier: "RU",
		doublesTier: "DOU",
	},
	lickitung: {
		tier: "LC",
	},
	lickilicky: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	koffing: {
		tier: "LC",
	},
	weezing: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	rhyhorn: {
		tier: "LC",
	},
	rhydon: {
		tier: "NU",
		doublesTier: "NFE",
	},
	rhyperior: {
		tier: "RU",
		doublesTier: "DUU",
	},
	happiny: {
		tier: "LC",
	},
	chansey: {
		tier: "OU",
		doublesTier: "NFE",
	},
	blissey: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	tangela: {
		tier: "PU",
		doublesTier: "NFE",
	},
	tangrowth: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	kangaskhan: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	kangaskhanmega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	horsea: {
		tier: "LC",
	},
	seadra: {
		tier: "NFE",
	},
	kingdra: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	goldeen: {
		tier: "LC",
	},
	seaking: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	staryu: {
		tier: "LC",
	},
	starmie: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	mimejr: {
		tier: "LC",
	},
	mrmime: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	scyther: {
		tier: "NU",
		doublesTier: "NFE",
	},
	scizor: {
		tier: "OU",
		doublesTier: "DOU",
	},
	scizormega: {
		tier: "OU",
		doublesTier: "(DOU)",
	},
	smoochum: {
		tier: "LC",
	},
	jynx: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	elekid: {
		tier: "LC",
	},
	electabuzz: {
		tier: "NFE",
	},
	electivire: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	magby: {
		tier: "LC",
	},
	magmar: {
		tier: "NFE",
	},
	magmortar: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	pinsir: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	pinsirmega: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	tauros: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	magikarp: {
		tier: "LC",
	},
	gyarados: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	gyaradosmega: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	lapras: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	ditto: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	eevee: {
		tier: "LC",
	},
	vaporeon: {
		tier: "UU",
		doublesTier: "DUU",
	},
	jolteon: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	flareon: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	espeon: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	umbreon: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	leafeon: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	glaceon: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	porygon: {
		tier: "LC",
	},
	porygon2: {
		tier: "UU",
		doublesTier: "DUU",
	},
	porygonz: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	omanyte: {
		tier: "LC",
	},
	omastar: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	kabuto: {
		tier: "LC",
	},
	kabutops: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	aerodactyl: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	aerodactylmega: {
		tier: "UU",
		doublesTier: "DUU",
	},
	munchlax: {
		tier: "LC",
	},
	snorlax: {
		tier: "UU",
		doublesTier: "DUU",
	},
	articuno: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	zapdos: {
		tier: "OU",
		doublesTier: "DOU",
	},
	moltres: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	dratini: {
		tier: "LC",
	},
	dragonair: {
		tier: "NFE",
	},
	dragonite: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	mewtwo: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegax: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mewtwomegay: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	mew: {
		tier: "OU",
		doublesTier: "DUU",
	},
	chikorita: {
		tier: "LC",
	},
	bayleef: {
		tier: "NFE",
	},
	meganium: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	cyndaquil: {
		tier: "LC",
	},
	quilava: {
		tier: "NFE",
	},
	typhlosion: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	totodile: {
		tier: "LC",
	},
	croconaw: {
		tier: "NFE",
	},
	feraligatr: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	sentret: {
		tier: "LC",
	},
	furret: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	hoothoot: {
		tier: "LC",
	},
	noctowl: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	ledyba: {
		tier: "LC",
	},
	ledian: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	spinarak: {
		tier: "LC",
	},
	ariados: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	chinchou: {
		tier: "LC",
	},
	lanturn: {
		tier: "NU",
		doublesTier: "DUU",
	},
	togepi: {
		tier: "LC",
	},
	togetic: {
		tier: "RU",
		doublesTier: "DUU",
	},
	togekiss: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	natu: {
		tier: "LC",
	},
	xatu: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	mareep: {
		tier: "LC",
	},
	flaaffy: {
		tier: "NFE",
	},
	ampharos: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	ampharosmega: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	azurill: {
		tier: "LC",
	},
	marill: {
		tier: "NFE",
	},
	azumarill: {
		tier: "OU",
		doublesTier: "DOU",
	},
	bonsly: {
		tier: "LC",
	},
	sudowoodo: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	hoppip: {
		tier: "LC",
	},
	skiploom: {
		tier: "NFE",
	},
	jumpluff: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	aipom: {
		tier: "LC",
	},
	ambipom: {
		tier: "RU",
		doublesTier: "DUU",
	},
	sunkern: {
		tier: "LC",
	},
	sunflora: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	yanma: {
		tier: "NFE",
	},
	yanmega: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	wooper: {
		tier: "LC",
	},
	quagsire: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	murkrow: {
		tier: "NFE",
	},
	honchkrow: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	misdreavus: {
		tier: "PU",
		doublesTier: "NFE",
	},
	mismagius: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	unown: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	wynaut: {
		tier: "LC",
	},
	wobbuffet: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	girafarig: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	pineco: {
		tier: "LC",
	},
	forretress: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	dunsparce: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	gligar: {
		tier: "UU",
		doublesTier: "NFE",
	},
	gliscor: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	snubbull: {
		tier: "LC",
	},
	granbull: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	qwilfish: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	shuckle: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	heracross: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	heracrossmega: {
		tier: "(OU)",
		doublesTier: "(DUU)",
	},
	sneasel: {
		tier: "RU",
		doublesTier: "NFE",
	},
	weavile: {
		tier: "OU",
		doublesTier: "DOU",
	},
	teddiursa: {
		tier: "LC",
	},
	ursaring: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	slugma: {
		tier: "LC",
	},
	magcargo: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	swinub: {
		tier: "LC",
	},
	piloswine: {
		tier: "NU",
		doublesTier: "NFE",
	},
	mamoswine: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	corsola: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	remoraid: {
		tier: "LC",
	},
	octillery: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	delibird: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	mantyke: {
		tier: "LC",
	},
	mantine: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	skarmory: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	houndour: {
		tier: "LC",
	},
	houndoom: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	houndoommega: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	phanpy: {
		tier: "LC",
	},
	donphan: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	stantler: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	smeargle: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	miltank: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	raikou: {
		tier: "(OU)",
		doublesTier: "(DUU)",
	},
	entei: {
		tier: "UU",
		doublesTier: "DUU",
	},
	suicune: {
		tier: "UU",
		doublesTier: "DOU",
	},
	larvitar: {
		tier: "LC",
	},
	pupitar: {
		tier: "NFE",
	},
	tyranitar: {
		tier: "OU",
		doublesTier: "DOU",
	},
	tyranitarmega: {
		tier: "(OU)",
		doublesTier: "(DOU)",
	},
	lugia: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	hooh: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	celebi: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	treecko: {
		tier: "LC",
	},
	grovyle: {
		tier: "NFE",
	},
	sceptile: {
		tier: "NUBL",
		doublesTier: "(DUU)",
	},
	sceptilemega: {
		tier: "UU",
		doublesTier: "DUU",
	},
	torchic: {
		tier: "LC",
	},
	combusken: {
		tier: "PU",
		doublesTier: "NFE",
	},
	blaziken: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	blazikenmega: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	mudkip: {
		tier: "LC",
	},
	marshtomp: {
		tier: "NFE",
	},
	swampert: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	swampertmega: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	poochyena: {
		tier: "LC",
	},
	mightyena: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	zigzagoon: {
		tier: "LC",
	},
	linoone: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	wurmple: {
		tier: "LC",
	},
	silcoon: {
		tier: "NFE",
	},
	beautifly: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	cascoon: {
		tier: "NFE",
	},
	dustox: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	lotad: {
		tier: "LC",
	},
	lombre: {
		tier: "NFE",
	},
	ludicolo: {
		tier: "NU",
		doublesTier: "DOU",
	},
	seedot: {
		tier: "LC",
	},
	nuzleaf: {
		tier: "NFE",
	},
	shiftry: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	taillow: {
		tier: "LC",
	},
	swellow: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	wingull: {
		tier: "LC",
	},
	pelipper: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	ralts: {
		tier: "LC",
	},
	kirlia: {
		tier: "NFE",
	},
	gardevoir: {
		tier: "UU",
		doublesTier: "DUU",
	},
	gardevoirmega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	gallade: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	gallademega: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	surskit: {
		tier: "LC",
	},
	masquerain: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	shroomish: {
		tier: "LC",
	},
	breloom: {
		tier: "OU",
		doublesTier: "DOU",
	},
	slakoth: {
		tier: "LC",
	},
	vigoroth: {
		tier: "PUBL",
		doublesTier: "NFE",
	},
	slaking: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	nincada: {
		tier: "LC",
	},
	ninjask: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	shedinja: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	whismur: {
		tier: "LC",
	},
	loudred: {
		tier: "NFE",
	},
	exploud: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	makuhita: {
		tier: "LC",
	},
	hariyama: {
		tier: "NU",
		doublesTier: "DUU",
	},
	nosepass: {
		tier: "LC",
	},
	probopass: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	skitty: {
		tier: "LC",
	},
	delcatty: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	sableye: {
		tier: "RUBL",
		doublesTier: "DUU",
	},
	sableyemega: {
		tier: "Uber",
		doublesTier: "DUU",
	},
	mawile: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	mawilemega: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	aron: {
		tier: "LC",
	},
	lairon: {
		tier: "NFE",
	},
	aggron: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	aggronmega: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	meditite: {
		tier: "NFE",
	},
	medicham: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	medichammega: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	electrike: {
		tier: "LC",
	},
	manectric: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	manectricmega: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	plusle: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	minun: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	volbeat: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	illumise: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	budew: {
		tier: "LC",
	},
	roselia: {
		tier: "PU",
		doublesTier: "NFE",
	},
	roserade: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	gulpin: {
		tier: "LC",
	},
	swalot: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	carvanha: {
		tier: "LC",
	},
	sharpedo: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	sharpedomega: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	wailmer: {
		tier: "LC",
	},
	wailord: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	numel: {
		tier: "LC",
	},
	camerupt: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	cameruptmega: {
		tier: "RU",
		doublesTier: "DUU",
	},
	torkoal: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	spoink: {
		tier: "LC",
	},
	grumpig: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	spinda: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	trapinch: {
		tier: "LC",
	},
	vibrava: {
		tier: "NFE",
	},
	flygon: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	cacnea: {
		tier: "LC",
	},
	cacturne: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	swablu: {
		tier: "LC",
	},
	altaria: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	altariamega: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	zangoose: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	seviper: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	lunatone: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	solrock: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	barboach: {
		tier: "LC",
	},
	whiscash: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	corphish: {
		tier: "LC",
	},
	crawdaunt: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	baltoy: {
		tier: "LC",
	},
	claydol: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	lileep: {
		tier: "LC",
	},
	cradily: {
		tier: "NU",
		doublesTier: "DUU",
	},
	anorith: {
		tier: "LC",
	},
	armaldo: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	feebas: {
		tier: "LC",
	},
	milotic: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	castform: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	castformsunny: {
	},
	castformrainy: {
	},
	castformsnowy: {
	},
	kecleon: {
		tier: "NU",
		doublesTier: "DUU",
	},
	shuppet: {
		tier: "LC",
	},
	banette: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	banettemega: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	duskull: {
		tier: "LC",
	},
	dusclops: {
		tier: "NFE",
	},
	dusknoir: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	tropius: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	chingling: {
		tier: "LC",
	},
	chimecho: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	absol: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	absolmega: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	snorunt: {
		tier: "LC",
	},
	glalie: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	glaliemega: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	froslass: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	spheal: {
		tier: "LC",
	},
	sealeo: {
		tier: "NFE",
	},
	walrein: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	clamperl: {
		tier: "LC",
	},
	huntail: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
	},
	gorebyss: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	relicanth: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	luvdisc: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	bagon: {
		tier: "LC",
	},
	shelgon: {
		tier: "NFE",
	},
	salamence: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	salamencemega: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	beldum: {
		tier: "LC",
	},
	metang: {
		tier: "PU",
		doublesTier: "NFE",
	},
	metagross: {
		tier: "UU",
		doublesTier: "DUU",
	},
	metagrossmega: {
		tier: "OU",
		doublesTier: "DUU",
	},
	regirock: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	regice: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	registeel: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	latias: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	latiasmega: {
		tier: "(OU)",
		doublesTier: "(DUU)",
	},
	latios: {
		tier: "OU",
		doublesTier: "DOU",
	},
	latiosmega: {
		tier: "(OU)",
		doublesTier: "(DOU)",
	},
	kyogre: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	kyogreprimal: {
	},
	groudon: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	groudonprimal: {
	},
	rayquaza: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	rayquazamega: {
		tier: "AG",
		doublesTier: "DUber",
	},
	jirachi: {
		tier: "(OU)",
		doublesTier: "DUber",
	},
	deoxys: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	deoxysattack: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	deoxysdefense: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	deoxysspeed: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	turtwig: {
		tier: "LC",
	},
	grotle: {
		tier: "NFE",
	},
	torterra: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	chimchar: {
		tier: "LC",
	},
	monferno: {
		tier: "PU",
		doublesTier: "NFE",
	},
	infernape: {
		tier: "UU",
		doublesTier: "DUU",
	},
	piplup: {
		tier: "LC",
	},
	prinplup: {
		tier: "PU",
		doublesTier: "NFE",
	},
	empoleon: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	starly: {
		tier: "LC",
	},
	staravia: {
		tier: "NFE",
	},
	staraptor: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	bidoof: {
		tier: "LC",
	},
	bibarel: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	kricketot: {
		tier: "LC",
	},
	kricketune: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	shinx: {
		tier: "LC",
	},
	luxio: {
		tier: "NFE",
	},
	luxray: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	cranidos: {
		tier: "LC",
	},
	rampardos: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	shieldon: {
		tier: "LC",
	},
	bastiodon: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	burmy: {
		tier: "LC",
	},
	wormadam: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	wormadamsandy: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	wormadamtrash: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	mothim: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	combee: {
		tier: "LC",
	},
	vespiquen: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	pachirisu: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	buizel: {
		tier: "LC",
	},
	floatzel: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	cherubi: {
		tier: "LC",
	},
	cherrim: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	cherrimsunshine: {
	},
	shellos: {
		tier: "LC",
	},
	gastrodon: {
		tier: "NU",
		doublesTier: "DOU",
	},
	drifloon: {
		tier: "NFE",
	},
	drifblim: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	buneary: {
		tier: "LC",
	},
	lopunny: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	lopunnymega: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	glameow: {
		tier: "LC",
	},
	purugly: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
	},
	stunky: {
		tier: "LC",
	},
	skuntank: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	bronzor: {
		tier: "LC",
	},
	bronzong: {
		tier: "RU",
		doublesTier: "DUU",
	},
	chatot: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	spiritomb: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	gible: {
		tier: "LC",
	},
	gabite: {
		tier: "PU",
		doublesTier: "NFE",
	},
	garchomp: {
		tier: "OU",
		doublesTier: "DOU",
	},
	garchompmega: {
		tier: "(OU)",
		doublesTier: "(DOU)",
	},
	riolu: {
		tier: "LC",
	},
	lucario: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	lucariomega: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	hippopotas: {
		tier: "LC",
	},
	hippowdon: {
		tier: "OU",
		doublesTier: "DUU",
	},
	skorupi: {
		tier: "LC",
	},
	drapion: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	croagunk: {
		tier: "LC",
	},
	toxicroak: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	carnivine: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	finneon: {
		tier: "LC",
	},
	lumineon: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	snover: {
		tier: "LC",
	},
	abomasnow: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	abomasnowmega: {
		tier: "RUBL",
		doublesTier: "DUU",
	},
	rotom: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	rotomheat: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	rotomwash: {
		tier: "OU",
		doublesTier: "DOU",
	},
	rotomfrost: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	rotomfan: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	rotommow: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	uxie: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	mesprit: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	azelf: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	dialga: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	palkia: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	heatran: {
		tier: "OU",
		doublesTier: "DOU",
	},
	regigigas: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
	},
	giratina: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	giratinaorigin: {
	},
	cresselia: {
		tier: "UU",
		doublesTier: "DOU",
	},
	phione: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	manaphy: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	darkrai: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	shaymin: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	shayminsky: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	arceus: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	arceusbug: {
	},
	arceusdark: {
	},
	arceusdragon: {
	},
	arceuselectric: {
	},
	arceusfairy: {
	},
	arceusfighting: {
	},
	arceusfire: {
	},
	arceusflying: {
	},
	arceusghost: {
	},
	arceusgrass: {
	},
	arceusground: {
	},
	arceusice: {
	},
	arceuspoison: {
	},
	arceuspsychic: {
	},
	arceusrock: {
	},
	arceussteel: {
	},
	arceuswater: {
	},
	victini: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	snivy: {
		tier: "LC",
	},
	servine: {
		tier: "NFE",
	},
	serperior: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	tepig: {
		tier: "LC",
	},
	pignite: {
		tier: "NFE",
	},
	emboar: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	oshawott: {
		tier: "LC",
	},
	dewott: {
		tier: "NFE",
	},
	samurott: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	patrat: {
		tier: "LC",
	},
	watchog: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	lillipup: {
		tier: "LC",
	},
	herdier: {
		tier: "NFE",
	},
	stoutland: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	purrloin: {
		tier: "LC",
	},
	liepard: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	pansage: {
		tier: "LC",
	},
	simisage: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	pansear: {
		tier: "LC",
	},
	simisear: {
		tier: "ZUBL",
		doublesTier: "(DUU)",
	},
	panpour: {
		tier: "LC",
	},
	simipour: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	munna: {
		tier: "LC",
	},
	musharna: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	pidove: {
		tier: "LC",
	},
	tranquill: {
		tier: "NFE",
	},
	unfezant: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	blitzle: {
		tier: "LC",
	},
	zebstrika: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	roggenrola: {
		tier: "LC",
	},
	boldore: {
		tier: "NFE",
	},
	gigalith: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	woobat: {
		tier: "LC",
	},
	swoobat: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	drilbur: {
		tier: "LC",
	},
	excadrill: {
		tier: "OU",
		doublesTier: "DUU",
	},
	audino: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	audinomega: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	timburr: {
		tier: "LC",
	},
	gurdurr: {
		tier: "NU",
		doublesTier: "NFE",
	},
	conkeldurr: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	tympole: {
		tier: "LC",
	},
	palpitoad: {
		tier: "NFE",
	},
	seismitoad: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	throh: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	sawk: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	sewaddle: {
		tier: "LC",
	},
	swadloon: {
		tier: "NFE",
	},
	leavanny: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	venipede: {
		tier: "LC",
	},
	whirlipede: {
		tier: "NFE",
	},
	scolipede: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	cottonee: {
		tier: "LC",
	},
	whimsicott: {
		tier: "UU",
		doublesTier: "DOU",
	},
	petilil: {
		tier: "LC",
	},
	lilligant: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	basculin: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	basculinbluestriped: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	sandile: {
		tier: "LC",
	},
	krokorok: {
		tier: "NFE",
	},
	krookodile: {
		tier: "UU",
		doublesTier: "DUU",
	},
	darumaka: {
		tier: "LC",
	},
	darmanitan: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	maractus: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	dwebble: {
		tier: "LC",
	},
	crustle: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	scraggy: {
		tier: "LC",
	},
	scrafty: {
		tier: "RU",
		doublesTier: "DOU",
	},
	sigilyph: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	yamask: {
		tier: "LC",
	},
	cofagrigus: {
		tier: "RU",
		doublesTier: "DUU",
	},
	tirtouga: {
		tier: "LC",
	},
	carracosta: {
		tier: "PUBL",
		doublesTier: "(DUU)",
	},
	archen: {
		tier: "LC",
	},
	archeops: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	trubbish: {
		tier: "LC",
	},
	garbodor: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	zorua: {
		tier: "LC",
	},
	zoroark: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	minccino: {
		tier: "LC",
	},
	cinccino: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	gothita: {
		tier: "LC",
	},
	gothorita: {
		tier: "NFE",
	},
	gothitelle: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	solosis: {
		tier: "LC",
	},
	duosion: {
		tier: "NFE",
	},
	reuniclus: {
		tier: "UU",
		doublesTier: "DUU",
	},
	ducklett: {
		tier: "LC",
	},
	swanna: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	vanillite: {
		tier: "LC",
	},
	vanillish: {
		tier: "NFE",
	},
	vanilluxe: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	deerling: {
		tier: "LC",
	},
	sawsbuck: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	emolga: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	karrablast: {
		tier: "LC",
	},
	escavalier: {
		tier: "RU",
		doublesTier: "DUU",
	},
	foongus: {
		tier: "LC",
	},
	amoonguss: {
		tier: "OU",
		doublesTier: "DOU",
	},
	frillish: {
		tier: "LC",
	},
	jellicent: {
		tier: "RU",
		doublesTier: "DUU",
	},
	alomomola: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	joltik: {
		tier: "LC",
	},
	galvantula: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	ferroseed: {
		tier: "NU",
		doublesTier: "LC",
	},
	ferrothorn: {
		tier: "OU",
		doublesTier: "DOU",
	},
	klink: {
		tier: "LC",
	},
	klang: {
		tier: "NFE",
	},
	klinklang: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	tynamo: {
		tier: "LC",
	},
	eelektrik: {
		tier: "NFE",
	},
	eelektross: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	elgyem: {
		tier: "LC",
	},
	beheeyem: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	litwick: {
		tier: "LC",
	},
	lampent: {
		tier: "NFE",
	},
	chandelure: {
		tier: "UU",
		doublesTier: "DUU",
	},
	axew: {
		tier: "LC",
	},
	fraxure: {
		tier: "ZUBL",
		doublesTier: "NFE",
	},
	haxorus: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	cubchoo: {
		tier: "LC",
	},
	beartic: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	cryogonal: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	shelmet: {
		tier: "LC",
	},
	accelgor: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	stunfisk: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	mienfoo: {
		tier: "LC",
	},
	mienshao: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	druddigon: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	golett: {
		tier: "LC",
	},
	golurk: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	pawniard: {
		tier: "PU",
		doublesTier: "LC",
	},
	bisharp: {
		tier: "OU",
		doublesTier: "DOU",
	},
	bouffalant: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	rufflet: {
		tier: "LC",
	},
	braviary: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	vullaby: {
		tier: "PU",
		doublesTier: "LC",
	},
	mandibuzz: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	heatmor: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	durant: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	deino: {
		tier: "LC",
	},
	zweilous: {
		tier: "NFE",
	},
	hydreigon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	larvesta: {
		tier: "LC",
	},
	volcarona: {
		tier: "UUBL",
		doublesTier: "DUU",
	},
	cobalion: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	terrakion: {
		tier: "UUBL",
		doublesTier: "DOU",
	},
	virizion: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	tornadus: {
		tier: "UU",
		doublesTier: "DUU",
	},
	tornadustherian: {
		tier: "OU",
		doublesTier: "(DUU)",
	},
	thundurus: {
		tier: "OU",
		doublesTier: "DOU",
	},
	thundurustherian: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	reshiram: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	zekrom: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	landorus: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	landorustherian: {
		tier: "OU",
		doublesTier: "DOU",
	},
	kyurem: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	kyuremblack: {
		tier: "OU",
		doublesTier: "DOU",
	},
	kyuremwhite: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	keldeo: {
		tier: "OU",
		doublesTier: "DOU",
	},
	keldeoresolute: {
		tier: "OU",
		doublesTier: "DOU",
	},
	meloetta: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	meloettapirouette: {
	},
	genesect: {
		tier: "Uber",
		doublesTier: "DUU",
	},
	genesectburn: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	genesectchill: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	genesectdouse: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	genesectshock: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	chespin: {
		tier: "LC",
	},
	quilladin: {
		tier: "NFE",
	},
	chesnaught: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	fennekin: {
		tier: "LC",
	},
	braixen: {
		tier: "NFE",
	},
	delphox: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	froakie: {
		tier: "LC",
	},
	frogadier: {
		tier: "NFE",
	},
	greninja: {
		tier: "Uber",
		doublesTier: "(DUU)",
	},
	bunnelby: {
		tier: "LC",
	},
	diggersby: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	fletchling: {
		tier: "LC",
	},
	fletchinder: {
		tier: "RU",
		doublesTier: "NFE",
	},
	talonflame: {
		tier: "OU",
		doublesTier: "DOU",
	},
	scatterbug: {
		tier: "LC",
	},
	spewpa: {
		tier: "NFE",
	},
	vivillon: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	litleo: {
		tier: "LC",
	},
	pyroar: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	flabebe: {
		tier: "LC",
	},
	floette: {
		tier: "NFE",
	},
	floetteeternal: {
		isNonstandard: "Unobtainable",
		tier: "Illegal",
	},
	florges: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	skiddo: {
		tier: "LC",
	},
	gogoat: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	pancham: {
		tier: "LC",
	},
	pangoro: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	furfrou: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	espurr: {
		tier: "LC",
	},
	meowstic: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	meowsticf: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	honedge: {
		tier: "LC",
	},
	doublade: {
		tier: "UU",
		doublesTier: "NFE",
	},
	aegislash: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	aegislashblade: {
	},
	spritzee: {
		tier: "LC",
	},
	aromatisse: {
		tier: "RU",
		doublesTier: "DUU",
	},
	swirlix: {
		tier: "NFE",
	},
	slurpuff: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	inkay: {
		tier: "LC",
	},
	malamar: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	binacle: {
		tier: "LC",
	},
	barbaracle: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	skrelp: {
		tier: "LC",
	},
	dragalge: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	clauncher: {
		tier: "LC",
	},
	clawitzer: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	helioptile: {
		tier: "LC",
	},
	heliolisk: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	tyrunt: {
		tier: "LC",
	},
	tyrantrum: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	amaura: {
		tier: "LC",
	},
	aurorus: {
		tier: "NU",
		doublesTier: "(DUU)",
	},
	sylveon: {
		tier: "UU",
		doublesTier: "DOU",
	},
	hawlucha: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	dedenne: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	carbink: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	goomy: {
		tier: "LC",
	},
	sliggoo: {
		tier: "NFE",
	},
	goodra: {
		tier: "UU",
		doublesTier: "DUU",
	},
	klefki: {
		tier: "UU",
		doublesTier: "(DUU)",
	},
	phantump: {
		tier: "LC",
	},
	trevenant: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	pumpkaboo: {
		tier: "LC",
	},
	pumpkaboosmall: {
		tier: "LC",
	},
	pumpkaboolarge: {
		tier: "LC",
	},
	pumpkaboosuper: {
		tier: "LC",
	},
	gourgeist: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	gourgeistsmall: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	gourgeistlarge: {
		tier: "ZU",
		doublesTier: "(DUU)",
	},
	gourgeistsuper: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	bergmite: {
		tier: "LC",
	},
	avalugg: {
		tier: "PU",
		doublesTier: "(DUU)",
	},
	noibat: {
		tier: "LC",
	},
	noivern: {
		tier: "RUBL",
		doublesTier: "(DUU)",
	},
	xerneas: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	yveltal: {
		tier: "Uber",
		doublesTier: "DUber",
	},
	zygarde: {
		tier: "UUBL",
		doublesTier: "(DUU)",
	},
	diancie: {
		tier: "RU",
		doublesTier: "DUU",
	},
	dianciemega: {
		tier: "OU",
		doublesTier: "DOU",
	},
	hoopa: {
		tier: "RU",
		doublesTier: "(DUU)",
	},
	hoopaunbound: {
		tier: "Uber",
		doublesTier: "DOU",
	},
	volcanion: {
		tier: "OU",
		doublesTier: "DOU",
	},
};
